export default "__VITE_ASSET__BBpt521O__"